import { SUBMIT_WEB_HOOK_URL } from '@/consts/urls';
import { getContext } from '@/context';
import getAuthJsonHeaders from '@/requests/common/getAuthJsonHeaders';

import type { ContentFileAttributes, NotificationConfig } from '@/types';

type SubmitWebhookData = {
  response: { id: string };
  status?: string;
  reason?: string;
};

type DriveOptions = {
  folderName: string;
  packageId?: string;
  // See `ContentFileAttributes` / docs/reference/api.md → "Drive attributes workaround".
  attributes?: ContentFileAttributes;
};

type Params = {
  webhookId: string;
  params: Record<string, unknown>;
  driveOptions?: DriveOptions;
  notificationConfig?: NotificationConfig;
};

const submitWebHook = async ({
  notificationConfig,
  ...params
}: Params): Promise<{ id: string }> => {
  const response = await getContext().utils.api.fetch(SUBMIT_WEB_HOOK_URL, {
    method: 'POST',
    body: JSON.stringify({
      params,
      ...(notificationConfig && { notification: notificationConfig }),
    }),
    headers: getAuthJsonHeaders(),
  });
  if (!response.ok) {
    const body = await response.text().catch(() => '');
    throw new Error(
      `Webhook submission failed: ${body || response.statusText}`
    );
  }
  const data: SubmitWebhookData = await response.json();
  if (!data?.response?.id) {
    throw new Error('Webhook response missing id field');
  }
  return { id: data.response.id };
};

export default submitWebHook;
